import * as React from "react";
import { style } from "typestyle";

interface IProps {
  size: number;
  color?: string;
  rotation?: number;
}

export const RightArrow2Icon = (props: IProps) => {
  const className = style({
    width: props.size,
    height: props.size,
    stroke: props.color,
    transform: `rotate(${props.rotation}deg)`
  });
  return (
    <React.Fragment>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
        className={className}
      >
        <path
          fill="none"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M13 2l22 22-22 22"
        />
      </svg>
    </React.Fragment>
  );
};
